import { FormattedMessage, useIntl } from '../../../../../util/reactIntl';
import React from 'react';
import css from './PhotographersOnSihmoCard.module.css';
import Slider from 'react-slick';
import IconCollection from '../../../../../components/IconCollection/IconCollection';

const AVATAR_COLORS = ['#FFC930', '#FF6713', '#223A46', '#64696B'];

const getInitials = name =>
  name
    .split(' ')
    .map(part => part.charAt(0))
    .join('')
    .toUpperCase();

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 35.5C27.665 35.5 35.5 27.665 35.5 18C35.5 8.33502 27.665 0.5 18 0.5C8.33502 0.5 0.5 8.33502 0.5 18C0.5 27.665 8.33502 35.5 18 35.5Z"
          fill="#FF6713"
          stroke="#FF6713"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect x="6.25" y="6.24951" width="23.5" height="23.5" stroke="#FF6713" />
        <path
          d="M14.9375 24.1245L21.0625 17.9995L14.9375 11.8745"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 35.5C8.33502 35.5 0.5 27.665 0.5 18C0.5 8.33502 8.33502 0.5 18 0.5C27.665 0.5 35.5 8.33502 35.5 18C35.5 27.665 27.665 35.5 18 35.5Z"
          fill="#FF6713"
          stroke="#FF6713"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="-0.5"
          y="0.5"
          width="23.5"
          height="23.5"
          transform="matrix(-1 0 0 1 29.25 5.74951)"
          stroke="#FF6713"
        />
        <path
          d="M21.0625 24.1245L14.9375 17.9995L21.0625 11.8745"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}

const photographers = [
  {
    name: 'Anna K.',
    titleId: 'PhotographersOnSihmoCard.role1',
    descriptionId: 'PhotographersOnSihmoCard.quote1',
  },
  {
    name: 'Luis M.',
    titleId: 'PhotographersOnSihmoCard.role2',
    descriptionId: 'PhotographersOnSihmoCard.quote2',
  },
  {
    name: 'Rosa M.',
    titleId: 'PhotographersOnSihmoCard.role3',
    descriptionId: 'PhotographersOnSihmoCard.quote3',
  },
  {
    name: 'Mike G.',
    titleId: 'PhotographersOnSihmoCard.role4',
    descriptionId: 'PhotographersOnSihmoCard.quote4',
  },
];

function PhotographersOnSihmoCard() {
  const intl = useIntl();
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const sliderRef = React.useRef(null);

  const handlePaginationClick = index => {
    sliderRef.current?.slickGoTo(index);
    setCurrentSlide(index);
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false,
    afterChange: current => setCurrentSlide(current),
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1, arrows: false } },
    ],
  };

  return (
    <div className={css.photgrapherWrapper}>
      <div className={css.photgrapherHeader}><FormattedMessage id="PhotographersOnSihmoCard.title" /></div>
      <div className={css.photgrapherSubHeader}>
        <FormattedMessage id="PhotographersOnSihmoCard.subtitle" />
      </div>
      <div className={css.photgrapherContent}>
        <Slider {...settings} ref={sliderRef}>
          {photographers.map((p, idx) => (
            <div key={`${p.name}-${idx}`} className={css.cardOuter}>
              <div className={css.card}>
                <div className={css.cardInfoWrapper}>
                  <div
                    className={css.avatarWrap}
                    style={{ backgroundColor: AVATAR_COLORS[idx % AVATAR_COLORS.length] }}
                  >
                    <span className={css.avatarInitials}>{getInitials(p.name)}</span>
                  </div>
                  <div className={css.name}>{p.name}</div>
                  <div className={css.role}>{intl.formatMessage({ id: p.titleId })}</div>
                  <div className={css.quote}>“{intl.formatMessage({ id: p.descriptionId })}”</div>
                </div>

                <div className={css.meta}>
                  <span className={css.metaDot}>
                    <IconCollection name={'user'} />
                  </span>
                  <span><FormattedMessage id="PhotographersOnSihmoCard.active" /></span>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className={css.mobilePagination}>
        {photographers.map((_, idx) => (
          <button
            key={idx}
            className={`${css.paginationDot} ${
              currentSlide === idx ? css.paginationDotActive : ''
            }`}
            onClick={() => handlePaginationClick(idx)}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
      {/* <div className={css.ctaRow}>
        <button className={css.ctaBtn}>Join as photographer</button>
      </div> */}
    </div>
  );
}

export default PhotographersOnSihmoCard;
